
import { Link } from 'react-router-dom';
import { productsData } from '../../../mocks/products';

const ProductsSection = () => {
  // Display first 8 products
  const featuredProducts = productsData.slice(0, 8);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Introduction */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-light text-gray-900 mb-6">Professional Photobiomodulation Systems</h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Nova Radiance provides commercial-grade infrared and photobiomodulation systems designed for clinics, physical therapy practices, performance centers, and recovery studios. Our systems combine high-output LED arrays, optimized wavelengths, and commercial durability for professional environments.
          </p>
        </div>

        {/* Header */}
        <div className="text-center mb-16">
          <h3 className="text-4xl font-light text-gray-900 mb-4">Our Products</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-2">
            Discover our comprehensive range of professional-grade photobiomodulation devices designed to support various therapeutic applications
          </p>
          <p className="text-sm text-gray-500 italic">
            Professional and facility procurement only. Consumer checkout is not available.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {featuredProducts.map((product) => (
            <Link 
              key={product.id}
              to={`/products/${product.id}`}
              className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-gray-100">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {product.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-teal-600 text-sm font-medium">Learn More</span>
                  <i className="ri-arrow-right-line text-teal-600 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Products Button */}
        <div className="text-center">
          <Link 
            to="/products"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-3 rounded-md hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Products
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
